const updates = [
  { title: '「她的私密生活」第 89 话更新', desc: '韩漫热榜第一作品最新话已上线，剧情迎来重大转折，伏笔回收引爆读者讨论。', time: '10分钟前', tag: '韩漫更新' },
  { title: '「咒术回战」最终章连载再开', desc: '日漫超人气作品回归，最终章连载正式启动，新角色登场引发全球热议。', time: '2小时前', tag: '日漫速报' },
  { title: '国漫「一人之下」第六季定档', desc: '官方宣布第六季制作决定，全新视觉图公开，预计下月正式上线连载。', time: '5小时前', tag: '国漫资讯' },
  { title: '樱花漫画新增 500+ 部韩漫作品', desc: '平台内容库再次扩充，新增多部高分韩漫完整版，涵盖恋爱、悬疑等多种题材。', time: '1天前', tag: '平台动态' },
  { title: '「电锯人」第二部动画化决定', desc: '藤本树原作超人气漫画第二部确定动画化，视觉图和制作阵容同步公开。', time: '2天前', tag: '日漫速报' },
  { title: '悬疑漫画专题：10部不可错过的烧脑神作', desc: '编辑精选悬疑推理漫画合集，从社会派到本格推理，每一部都值得反复品味。', time: '3天前', tag: '编辑推荐' },
  { title: '阅读体验升级：新增夜间模式与字号调节', desc: '樱花漫画移动端功能优化，支持深色背景阅读和自定义字号，护眼更舒适。', time: '4天前', tag: '功能更新' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            最新动态
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            漫画世界的新鲜事
          </h2>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300/60 hidden sm:block"></div>
          <div className="space-y-5">
            {updates.map((item, i) => (
              <div key={i} className="flex gap-4">
                <div className="hidden sm:flex flex-col items-center">
                  <div className={`w-[10px] h-[10px] rounded-full mt-1.5 flex-shrink-0 ${
                    i === 0 ? 'bg-primary-500 ring-4 ring-primary-100' : 'bg-background-300'
                  }`}></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium">{item.tag}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-foreground-500">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}